// extracted by mini-css-extract-plugin
export default {"phoneLabel":"phoneInput_phoneLabel__T-r7S","phoneInput":"phoneInput_phoneInput__v66OX","PhoneNumber":"phoneInput_PhoneNumber__KgmXF"};